import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { Text } from '@adsk/alloy-react-box';
import { SheetsIcon } from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import EntityMenuItem from '../../EntityMenuItem';

const SheetEntityMenuItem = ({ entity, onClick, ...rest }) => {
  const projectId = useCurrentProjectId();
  const { sheetId, versionSet, name, collection } = entity;
  const url = `/build/sheets/projects/${projectId}?moduleId=2d&entityId=${sheetId}`;
  const handleClick = () => {
    onClick?.(entity);
  };
  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span
        style={{
          display: 'flex',
          paddingLeft: 6,
          color: Theme.colors.charcoal900,
        }}
      >
        <OverflowTooltip
          getTargetProps={() => ({ style: { maxWidth: '100px' } })}
          autoTipOnEllipsis
        >
          {name}
        </OverflowTooltip>
        (
        <OverflowTooltip
          getTargetProps={() => ({ style: { maxWidth: '100px' } })}
          autoTipOnEllipsis
        >
          {versionSet.name}
        </OverflowTooltip>
        )
        {!!collection?.name && collection?.type !== 'default' && (
          <>
            <Text padding="0px 4px" color="charcoal400">
              |
            </Text>
            <OverflowTooltip
              getTargetProps={() => ({
                style: {
                  overflow: 'hidden',
                  maxWidth: '50%',
                  color: Theme.colors.charcoal900,
                },
              })}
              content={collection.name}
            >
              {collection.name}
            </OverflowTooltip>
          </>
        )}
      </span>
    </div>
  );
  return (
    <EntityMenuItem
      onClick={handleClick}
      link={url}
      label={label}
      renderIcon={SheetsIcon.renderIcon}
      {...rest}
    />
  );
};

export default SheetEntityMenuItem;
